import { INITIAL_RATING } from './ratingCalculations';
// Replaying this semester must start at the saved boundary, not erase prior seasons.
export function semesterStartRating(player, category) {
 const rating = player.season_start_ratings?.[category];
 return Number.isFinite(rating) ? rating : INITIAL_RATING;
}
